import type * as lazyIndex from './lazyIndex';
import { LazyAction, LazyModule, LazyImport } from 'owa-bundling';

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule<typeof lazyIndex>(
    () => import(/* webpackChunkName: "MailSafeLinkShared" */ './lazyIndex'),
    {
        name: 'MailSafeLinkShared',
    }
);

export const lazyOnClickComposeLink: LazyAction<
    typeof lazyIndex.onClickComposeLink,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.onClickComposeLink);
export const lazyHandleLinkClickViaSafelinks: LazyAction<
    typeof lazyIndex.handleLinkClickViaSafelinks,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.handleLinkClickViaSafelinks);
export const lazyHandleLinkClick: LazyAction<typeof lazyIndex.handleLinkClick, typeof lazyModule> =
    new LazyAction(lazyModule, m => m.handleLinkClick);

export const lazyCreateUrlDetectionContentHandler: LazyImport<
    typeof lazyIndex.createUrlDetectionContentHandler,
    typeof lazyModule
> = new LazyImport(lazyModule, m => m.createUrlDetectionContentHandler);
export const lazyRefreshSafelinksPolicy: LazyImport<
    typeof lazyIndex.refreshSafelinksPolicy,
    typeof lazyModule
> = new LazyImport(lazyModule, m => m.refreshSafelinksPolicy);
export const lazyGetSafelinksPolicyRefreshStatus: LazyImport<
    typeof lazyIndex.getSafelinksPolicyRefreshStatus,
    typeof lazyModule
> = new LazyImport(lazyModule, m => m.getSafelinksPolicyRefreshStatus);
export const addOnClickHandler: LazyAction<typeof lazyIndex.addOnClickHandler, typeof lazyModule> =
    new LazyAction(lazyModule, m => m.addOnClickHandler);

export const lazyOpenJunkLinkVerification: LazyImport<
    typeof lazyIndex.openJunkLinkVerification,
    typeof lazyModule
> = new LazyImport(lazyModule, m => m.openJunkLinkVerification);
